import { useMemo } from 'react';
import { Content } from 'src/contexts/ContentContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { DetailSection } from 'src/modals/common';
import { AutoSourceTickets } from 'src/modals/SaleDetails/components/AutoSourceTickets';
import { useShouldHideForWastedSale } from 'src/modals/SaleDetails/hooks/useShouldHideForWastedSale';
import {
  AllocatedListing,
  AllocatedListings,
} from 'src/modals/SaleDetailsV2/components/SaleTickets/AllocatedListing';
import { OriginalListing } from 'src/modals/SaleDetailsV2/components/SaleTickets/OriginalListing';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature, SaleDetails } from 'src/WebApiController';

interface SeatsSoldAsProps {
  sale: SaleDetails | undefined | null;
}

export const SaleTicketsSection = ({ sale }: SeatsSoldAsProps) => {
  const hideForWastedSale = useShouldHideForWastedSale(sale);
  const hasSpoilTicketsInSaleFeature = useUserHasFeature(
    Feature.SpoilTicketsInSale
  );

  const listingAllocation = useMemo(() => {
    if (!sale || hideForWastedSale || !sale.tickets.length) {
      return null;
    }
    if (hasSpoilTicketsInSaleFeature) {
      return <AllocatedListings sale={sale} />;
    }
    return <AllocatedListing sale={sale} />;
  }, [hasSpoilTicketsInSaleFeature, hideForWastedSale, sale]);

  if (!sale) {
    return null;
  }

  return (
    <DetailSection name={<Content id={ContentId.Tickets} />}>
      {listingAllocation}
      <OriginalListing sale={sale} />
      <AutoSourceTickets isSeatSaver={sale?.isSeatSaver} />
    </DetailSection>
  );
};
